// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3OiY2","containerItemsCenter":"Skeleton_containerItemsCenter__2yEov"};